import React, { useEffect, useRef } from "react";
import "./HoppersAboutus.scss"
import team1 from "../../assets/team1.jpg"
import team2 from "../../assets/team2.jpg"
import team3 from "../../assets/team3.jpg"
import team4 from "../../assets/team4.jpg"
import Carousel from "../../components/Carousel/Carousel";
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";




const HoppersAboutus = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "about")
    const Components = page?.Components || []
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const members = [
        {
            "image": team1,
            "name": "Chef Marcus Johnson",
            "designation": "Executive Chef",
            "description": "Over 20 years of culinary excellence in Michelin-starred restaurants"
        }, {
            "image": team2,
            "name": "Chef Isabella Rodriguez",
            "designation": "Pastry Chef",
            "description": "Award-winning pastry artist specializing in French patisserie techniques"
        }, {
            "image": team3,
            "name": "Chef David Chen",
            "designation": "Sous Chef",
            "description": "Master of Asian fusion cuisine with innovative cooking techniques"
        }, {
            "image": team4,
            "name": "Chef Sarah Thompson",
            "designation": "Head Sommelier",
            "description": "Wine expert with extensive knowledge of international vintages"
        }
    ]
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "HoppersAboutus-Hero-header":
                return <div className="HoppersAboutus-Hero-header">
                    {component?.Props?.text}

                </div>
            case "HoppersAboutus-Hero-subheader":
                return <div className="HoppersAboutus-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="HoppersAboutus-Hero"
                style={{
                    backgroundImage: `linear-gradient(#00000099,#00000099), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}

            </div>
        )
    }
    const getLeftAboutComponents = (component) => {
        switch (component.ID) {
            case "HoppersAboutus-Content-left-subheader":
                return <div className="HoppersAboutus-Content-left-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersAboutus-Content-left-header":
                return <div className="HoppersAboutus-Content-left-header">
                    {component?.Props?.text}
                </div>
            case "HoppersAboutus-Content-left-img":
                return <img className="HoppersAboutus-Content-left-img"
                    src={component?.Props?.src} />
            case "HoppersAboutus-Content-left-content":
                return <div className="HoppersAboutus-Content-left-content">
                    {component?.Props?.content1}
                    <br />
                    <br />
                    {component?.Props?.content2}

                </div>
            default:
                return <div />
        }

    }
    const getLefAboutContent = (components) => {
        return (
            <div className="HoppersAboutus-Content-left">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getLeftAboutComponents(component)
                    )
                })}
            </div>
        )
    }
    const getAboutComponent = (component) => {
        switch (component.ID) {
            case "HoppersAboutus-Content-left":
                return getLefAboutContent(component?.Components)
            case "HoppersAboutus-Content-right":
                return <img alt="" className="HoppersAboutus-Content-right"
                    src={component?.Props?.src} />
            default:
                return <div />
        }

    }
    const getAboutContent = (components) => {
        return (
            <div className="HoppersAboutus-Content">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getAboutComponent(component)
                    )
                })}
            </div>
        )
    }
    const getAboutusList = (components) => {
        return (
            <div className="HoppersAboutus-List">
                {components?.map((data, key) => {
                    return (
                        <div className="HoppersAboutus-List-item" key={key}>
                            <div className="HoppersAboutus-List-item-ic">
                                <img alt="" src={data?.icon} />
                            </div>
                            <div className="HoppersAboutus-List-item-count">{data?.count}
                            </div>
                            <div className="HoppersAboutus-List-item-header">{data?.header}
                            </div>
                            <div className="HoppersAboutus-List-item-subheader">{data?.subheader}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
    const getVideoPlayer = (src) => {
        return (

            <div className="HoppersAboutus-Player">
                <iframe
                    style={{
                        height: "612px",
                        width: "100%",
                        borderRadius: "8px",
                        objectFit: "cover",
                    }}
                    src={src}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                ></iframe>
            </div>
        )
    }
    const getAboutusList2Component = (component) => {
        switch (component.ID) {
            case "HoppersAboutus-List2-subheader":
                return <div className="HoppersAboutus-List2-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersAboutus-List2-header":
                return <div className="HoppersAboutus-List2-header">
                    {component?.Props?.text}
                </div>
            case "HoppersAboutus-List2-flex":
                return <div className="HoppersAboutus-List2-flex">
                    {component?.Data?.map((data, key) => {
                        return (
                            <div className="HoppersAboutus-List2-flex-item" key={key}>
                                <div className="HoppersAboutus-List2-flex-item-ic">
                                    <img alt="" src={data?.icon} />
                                </div>
                                <div className="HoppersAboutus-List2-flex-item-header">{data?.header}
                                </div>
                                <div className="HoppersAboutus-List2-flex-item-subheader">{data?.subheader}
                                </div>
                            </div>
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getAboutusList2 = (components) => {
        return (
            <div className="HoppersAboutus-List2">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getAboutusList2Component(component)
                    )
                })}
            </div>
        )
    }
    const getReviewComponent = (component) => {
        switch (component.ID) {
            case "HoppersAboutus-Review-header":
                return <div className="HoppersAboutus-Review-header">
                    {component?.Props?.text}
                </div>
            case "HoppersAboutus-Review-subheader":
                return <div className="HoppersAboutus-Review-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersAboutus-ReviewList":
                return <Carousel items={component?.Data} />
            default:
                return <div />
        }

    }
    const getReview = (components) => {
        return (
            <div className="HoppersAboutus-Review" >
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getReviewComponent(component)
                    )
                })}
            </div >
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="HoppersAboutus-ImageCarousel" ref={containerRef}>
                <div className="HoppersAbout-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="HoppersAbout-Cont-image" />
                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersAboutus-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "HoppersAboutus-Content":
                return getAboutContent(component.Components)
            case "HoppersAboutus-List":
                return getAboutusList(component?.Data)
            case "HoppersAboutus-Player":
                return getVideoPlayer(component?.Props?.src)
            case "HoppersAboutus-List2":
                return getAboutusList2(component.Components)
            case "HoppersAboutus-Review":
                return getReview(component.Components)
            case "HoppersAboutus-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersAboutus" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
            {/* <div className="HoppersAboutus-Team">
                <div className="HoppersAboutus-Team-subheader">
                    Experience Team Member
                </div>
                <div className="HoppersAboutus-Team-header">
                    Meet Our Professional Chefs
                </div>
                <div className="HoppersAboutus-Team-grid">
                    {members.map((data, key) => {
                        return (
                            <div key={key} className="HoppersAboutus-Team-grid-item">
                                <img
                                    alt="" src={data?.image}
                                    className="HoppersAboutus-Team-grid-item-image" />
                                <div className="HoppersAboutus-Team-grid-item-cont">
                                    <div className="HoppersAboutus-Team-grid-item-cont-header">
                                        {data?.name}
                                    </div>
                                    <div className="HoppersAboutus-Team-grid-item-cont-subheader">
                                        {data?.designation}
                                    </div>  <div className="HoppersAboutus-Team-grid-item-cont-content">
                                        {data?.description}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div> */}
        </div >
    )
}
export default HoppersAboutus